import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { WIDGETS_QUERY_KEY } from './useWidgetsAPI';

export default function useWidgetsMutations() {
  const okapiKy = useOkapiKy();
  const queryClient = useQueryClient();

  const invalidate = () => queryClient.invalidateQueries([WIDGETS_QUERY_KEY]);

  const createWidget = useMutation({
    mutationFn: (widgetData) => okapiKy.post('widgets', { json: widgetData }).json(),
    onSuccess: invalidate,
  });

  const updateWidget = useMutation({
    mutationFn: ({ id, ...widgetData }) =>
      okapiKy.put(`widgets/${id}`, { json: { id, ...widgetData } }),
    onSuccess: invalidate,
  });

  const deleteWidget = useMutation({
    mutationFn: (widgetId) => okapiKy.delete(`widgets/${widgetId}`),
    onSuccess: invalidate,
  });

  const getWidget = (widgetId) => okapiKy.get(`widgets/${widgetId}`).json();

  return {
    createWidget,
    updateWidget,
    deleteWidget,
    getWidget,
  };
}
